import { Pagination, Spin } from "antd";
import { useContext, useEffect } from "react";
import List from "./List";
import mainContext from "../context/MainContext/mainContext";
import { FaInbox } from "react-icons/fa";

const SOBilledContent = () => {
  const {
    searchQuery,
    pageSize,
    pageNumber,
    setPageNumber,
    setPageSize,
    fetchSalesOrders,
    salesOrders,
    fetchToggle,
    totalOrders,
    searchToggle,
    loading,
    fetchInvoiceDataForCreditNote,
    preservePageNumberOnNextListMount,
    setPreservePageNumberOnNextListMount,
    financialYear,
  } = useContext(mainContext);

  const handlePageChange = (page, size) => {
    setPageNumber(page);
    setPageSize(size);
  };
  useEffect(() => {
    fetchInvoiceDataForCreditNote();

  }, []);
  useEffect(() => {
    if (preservePageNumberOnNextListMount) {
      setPreservePageNumberOnNextListMount(false);
    } else {
      setPageNumber(1);
    }
  }, []);

  useEffect(() => {
    // console.log("Fetching billed sales orders...");
    fetchSalesOrders("billed");
  }, [pageNumber, pageSize, fetchToggle, financialYear]);

  const filteredOrders = salesOrders?.filter((order) => {
    // console.log("Order:", order);
    return order.SOConfirmed === true;
  });

  useEffect(() => {
    // Clamp to a valid last page if delete/update reduces total count.
    const totalOrdersCount = totalOrders || { pending: 0, confirmed: 0, billed: 0 };
    const totalCount = searchToggle
      ? filteredOrders?.length || 0
      : totalOrdersCount.billedOrders || 0;

    const totalPages = Math.ceil((totalCount || 0) / (pageSize || 1));
    const safeTotalPages = totalPages > 0 ? totalPages : 1;

    if (pageNumber > safeTotalPages) {
      setPageNumber(safeTotalPages);
    }
  }, [
    totalOrders,
    searchToggle,
    filteredOrders?.length,
    pageSize,
    pageNumber,
    setPageNumber,
  ]);

  // console.log("Raw sales orders:", salesOrders);
  // console.log("Filtered orders:", filteredOrders);
  // console.log("Total orders count:", totalOrders);

  const getTotalCount = () => {
    let totalOrdersCount = totalOrders || { pending: 0, confirmed: 0, billed: 0 };

    let total;

    if (searchToggle) {
      total = filteredOrders.length;
    } else {
      total = totalOrdersCount.billedOrders;
    }

    console.log(`Total Count: ${total}`);
    return total;
  };

  return (
    <div className="salesOrder-tab-list">
      <div className="salesOrder-list-container">
        {loading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100px",
            }}
          >
            <Spin size="large" />
          </div>
        ) : filteredOrders && filteredOrders.length > 0 ? (
          filteredOrders.map((order) => <List key={order._id} order={order} type="billed" />)
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "gray",
              marginBottom: "1rem",
            }}
          >
            <FaInbox /> No billed sales orders yet!
          </div>
        )}

        <Pagination
          style={{ margin: "auto" }}
          current={pageNumber}
          pageSize={pageSize}
          total={getTotalCount()}
          onChange={handlePageChange}
          showSizeChanger
          pageSizeOptions={["10", "20", "50"]}
          defaultPageSize={10}
        />
      </div>
    </div>
  );
};

export default SOBilledContent; 